import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import {
    ActivatedRoute,
    Router,
} from '@angular/router';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import UiValidators, { UI_PASSWORD_MAX_LENGTH } from '@validators';

import { BehaviorSubject } from 'rxjs';
import {
    finalize,
    switchMap,
} from 'rxjs/operators';

@Component({
    templateUrl: 'password-change.page.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordChangePageComponent implements OnInit {
    public loading$ = new BehaviorSubject(false);
    public form: FormGroup;

    constructor(
        fb: FormBuilder,
        public auth: AuthService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _translateService: TranslateService,
        private _snack: UiSnackBarService,
        private _appState: AppStateFacade,
    ) {
        this.form = fb.group({
            'userId': [''],
            'code': [''],
            'password': ['', Validators.compose([
                Validators.required,
                Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
            ])],
            'confirmPassword': [''],
        }, {
                validator: UiValidators.confirmPassword('password', 'confirmPassword'),
            });
    }

    ngOnInit() {
        const [code, userId] = [
            history.state.code,
            this._route.snapshot.queryParamMap.get('userId'),
        ];

        // sanity check
        if (!code) {
            this._router.navigate(['/account/login']);
        }

        this.form.controls['userId'].setValue(userId);
        this.form.controls['code'].setValue(code);
    }

    public onSubmit(event: Event) {
        event.preventDefault();
        if (!this.form.valid) {
            return;
        }
        this.loading$.next(true);

        this.auth.changePassword(this.form.value)
            .pipe(
                switchMap(() => this._appState.user.ensureCorrectIdentity()),
                finalize(
                    () => this.loading$.next(false),
                ),
            )
            .subscribe(() => {
                this._snack.success(this._translateService.instant('password_change_success_message'));
                this._router.navigate(['/account/login']);
            });
    }
}
